<script>
  import { useForm } from '@inertiajs/svelte'
  import Layout from '../../layouts/layout.svelte'
  import PageHeader from '../../components/page_header.svelte'
  import FormLayout from '../../components/form_layout.svelte'
  import FormSection from '../../components/form_section.svelte'
  import TextField from '../../components/form/text_field.svelte'
  import CheckboxField from '../../components/form/checkbox_field.svelte'
  import SubmitButton from '../../components/form/submit_button.svelte'
  import { Button } from '../../components/ui'
  import { liveValidate } from '../../lib/live_validation.svelte.js'

  let { user = {}, back_url: backUrl = '/users' } = $props()

  // Validation is the server's: each change is checked live by a Precognition request to
  // the real create action, and again on Save.
  const form = useForm({
    user: {
      name: user.name || '',
      email: user.email || '',
      phone: user.phone || '',
      referral_code: user.referral_code || '',
      referral_program: user.referral_program || false,
      influencer_program: user.influencer_program || false,
      quest_curator: user.quest_curator || false
    },
    return_to: backUrl
  }).withPrecognition('post', '/users')
  liveValidate(form, 'user')

  const submit = (event) => {
    event.preventDefault()
    $form.post('/users')
  }
</script>

<Layout>
  <PageHeader title="New User" subtitle="Create an app member account" />

  <FormLayout onsubmit={submit}>
    <FormSection title="Account">
      <TextField bind:value={$form.user.email} label="Email" name="email" error={$form.errors['user.email']} />
      <TextField bind:value={$form.user.name} label="Full Name" name="name" error={$form.errors['user.name']} />
      <TextField bind:value={$form.user.phone} label="Phone Number" name="phone" error={$form.errors['user.phone']} />
      <TextField bind:value={$form.user.referral_code} label="Referral Code" name="referral_code" error={$form.errors['user.referral_code']} />
      <CheckboxField bind:checked={$form.user.referral_program} label="Referral Program" name="referral_program" />
      <CheckboxField bind:checked={$form.user.influencer_program} label="Influencer Program" name="influencer_program" />
      <CheckboxField bind:checked={$form.user.quest_curator} label="Quest Curator" name="quest_curator" />
    </FormSection>

    {#snippet footer()}
      <Button href={backUrl} variant="ghost" size="sm">Cancel</Button>
      <SubmitButton processing={$form.processing} label="Save" full={false} />
    {/snippet}
  </FormLayout>
</Layout>
